// @ts-nocheck
import { put, select, takeLatest } from 'redux-saga/effects';

import { storeObjectTreeDrivers } from '@/actions/commonActions';
import { pdcFetchInspections, setFilter } from '@/actions/pdcActions';
import { DRIVER_FILTER, FILTER_PDC_BY_SELECTED_DRIVERS, LOAD_OBJECT_TREE } from '@/constants';
import { getDrivers } from '@/selectors';

export function* doLoadObjectTree() {
    const drivers = yield select(getDrivers);
    yield put(storeObjectTreeDrivers(drivers));
}

export function* loadObjectTreeSaga() {
    yield takeLatest(LOAD_OBJECT_TREE, doLoadObjectTree);
}

export function* doFilterPDCBySelectedDrivers(action) {
    yield put(setFilter(DRIVER_FILTER, action.payload.driverIds));
    yield put(pdcFetchInspections());
}

export function* filterPDCBySelectedDrivers() {
    yield takeLatest(FILTER_PDC_BY_SELECTED_DRIVERS, doFilterPDCBySelectedDrivers);
}
